@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.info-icon {
  height: 13px;
  width: 13px;
  color: var(--grey-600);
}
